import { OutOfBandTransactionStatus } from "@modules/finances/boxPaymentAtCounter/entities/outOfBandTransactionType"
import { TransactionStatus } from "@modules/finances/types/financesType"
import { z } from "zod"

export const CustomerHistoryDtoSchema = z
  .object({
    transactionId: z.string(),
    name: z.string().nullable(),
    amount: z.number(),
    currency: z.string(),
    date: z.string(),
    status: z.enum(TransactionStatus),
  })
  .meta({ id: "CustomerHistoryDtoSchema" })

export type CustomerHistoryDto = z.infer<typeof CustomerHistoryDtoSchema>

export const OutOfBandCustomerHistoryDtoSchema = z
  .object({
    invoiceId: z.string(),
    name: z.string().nullable(),
    amount: z.number(),
    currency: z.string(),
    date: z.string(),
    status: z.enum(OutOfBandTransactionStatus),
  })
  .meta({ id: "OutOfBandCustomerHistoryDtoSchema" })

export type OutOfBandCustomerHistoryDto = z.infer<typeof OutOfBandCustomerHistoryDtoSchema>
